import { Panel, PanelType } from "@fluentui/react";
import React, { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import BaseTelelirk from "../../../../components/generic/baseTelerik";
import themeBase from "../../../../utils/theme/themeBase";

interface IPanelReporteTelerikAdminIperc {
  isOpen: boolean;
  onDismiss: () => void;
}

export const PanelReporteTelerikAdminIperc = (
  props: IPanelReporteTelerikAdminIperc
) => {
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"cabecera"}
          nameIconHeader=""
          subTextHeader="Reporte General de Iperc "
          textHeader="Reporte Iperc"
        />
      </>
    ),
    []
  );
  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderHeader={onRenderHeaderPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.large}
        isLightDismiss
      >
        <div style={themeBase._padding20}>
          <BaseTelelirk
            reportName="IPERCReporteHistorico.trdx"
            parametros={{}}
          />
        </div>
      </Panel>
    </div>
  );
};
